module.exports = __webpack_public_path__ + "static/media/viewIcon.5fc5edee.svg";